<template>
  <div class="main-configurations" v-loading="loadingOrganizations">
    <nav v-if="organization">
      <el-select v-model="organizationId" style="width: 100%" v-if="organizations.length > 1" filterable>
        <el-option
          v-for="organization in organizations"
          :key="organization.id"
          :label="organization.name"
          :value="organization.id">
        </el-option>
      </el-select>
      <ul>
        <the-tree v-for="branch in branchs" :branch="branch" :key="branch.label">
          <template v-slot:label="{ branch }">
            <router-link :to="{ name: branch.to, params : { name: organization.name }}" v-if="!branch.children">
              <i v-if="branch.icon" :class="branch.icon"></i>
              <span>{{ branch.label }}</span>
            </router-link>
            <span v-else>
              <i v-if="branch.icon" :class="branch.icon"></i>
              <span >{{ branch.label }}</span>
            </span>
          </template>
        </the-tree>
      </ul>
    </nav>
    <div class="view" v-if="organization">
      <TheBreadCrumbs :data="breadCrumbs" class="breadcrumbs" />
      <router-view  name="configuration" :key="$route.params.name"/>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%">
      <p>{{ $t("contact-me.to-continue-you-have-to-select-an-organization-to-manage") }}</p>
      <el-form ref="form" :model="form" size="medium" label-position="top">
        <el-form-item label="Organizations">
          <el-select v-model="form.organization" style="width: 100%" filterable :loading="organizations.length === 0">
            <el-option
              v-for="organization in organizations"
              :key="organization.id"
              :label="organization.name"
              :value="organization.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" style="margin-left: auto; display: block" @click="handleContinue" :disabled="form.organization === null">{{ $t('common.continue') }}</el-button>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import TheTree from '@/components/common/TheTree'
import TheBreadCrumbs from '@/components/common/TheBreadCrumbs'
export default {
  props: {
    name: {
      required: false
    }
  },
  data () {

    let mainMenu = [
        {
          label: this.$t('configuration.users.title'),
          icon: 'fas fa-users',
          to: 'users'
        },
        {
          label: this.$t('contact-me.form.title'),
          icon: 'fab fa-wpforms',
          to: 'formsList'
        },
        {
          label: 'Chat Center',
          icon: 'fas fa-comments',
          children: [
            {
              label: this.$t('contact-me.chat-center.providers'),
              to: 'chatProvidersList'
            },
            {
              label: this.$t('contact-me.chat-center.deparments'),
              to: 'departmentsList',
            },
            {
              label: this.$t('contact-me.chat-center.time-conditions'),
              to: 'timeConditionList'
            },
            {
              label: 'Bots',
              to: 'botsList'
            },
            {
              label: this.$t('contact-me.chat-center.chat-dispositions'),
              to: 'chatDispositionsList'
            },
            {
              label: this.$t('contact-me.chat-center.quick-response-template.menu-title'),
              to: 'quickResponseTemplatesList'
            },
            {
              label: this.$t('contact-me.chat-center.chat-classification'),
              to: 'chatClassificationList'
            },
          ]
        },
        {
          label: 'PBX',
          icon: 'fas fa-phone',
          children: [
            {
              label: this.$t('configuration.extensions.title'),
              to: 'extensions'
            }
          ]
        },
        {
          label: this.$t('configuration.agents.title'),
          icon: 'fas fa-headset',
          to: 'agents'
        },
        {
          label: 'Phone widget',
          icon: 'fas fa-mobile-alt',
          to: 'phoneWidgetsList'
        }
    ];

    if (this.$store.getters['isAdmin']) {
      mainMenu[2].children.push({
          label: 'Facebook Pages',
          to: 'socialPagesList',
      })

      mainMenu[2].children.push({
        label: 'Cache chats',
        to: 'cacheChats'
      })
    }

    return {
      mainMenu: mainMenu,
      form: {
        organization: null
      },
      dialogVisible: this.name ? false : true,
      loadingOrganizations: true
    }
  },
  components: {
    TheTree,
    TheBreadCrumbs
  },
  methods: {
    handleContinue() {
      this.organizationId = this.form.organization
      this.dialogVisible = false
    },
    findItemByTo(menu, to) {
      for (const item of menu) {
          if (item.to === to) {
              return item;
          }
          if (item.children) {
              const found = this.findItemByTo(item.children, to);
              if (found) {
                  return found;
              }
          }
      }
      return null;
    },
    setOrganizations(organizations) {
      this.organizations = organizations
    }
  },
  computed: {
    organizations() {
      return this.$store.getters['contactMe/getOrganizations']
    },
    organization() {
      return this.organizations.find(organization => organization.id === this.organizationId)
    },
    organizationId: {
      set(organizationId) {
        this.$store.commit("contactMe/SET_ORGANIZATION_ID", organizationId );
      },
      get() {
        return this.$store.getters['contactMe/getOrganizationId']
      }
    },
    breadCrumbs() {
      const currentRoute = this.$route.fullPath.split('/')

      const defaultValues = [
        { label: 'Configurations' },
        { label: this.organization.name },
      ]

      const section = currentRoute.at(3);

      if (/(chat-center|call-center|pbx)/.test(currentRoute)) {
        const centers = {
          'chat-center' : 'Chat Center',
          'call-center' : 'Call Center',
          'mail-center' : 'Mail Center',
          'pbx' : 'PBX',
        }
        defaultValues.push({
          label: centers[section]
        })
      } 

      const selectMenu = this.findItemByTo(this.branchs, this.$route.name)
      if (selectMenu) {
        defaultValues.push({
          label: selectMenu.label
        })
      }

      return defaultValues
    },
    currentClient() {
      return this.$route
    }, 
    branchs() {
      const always = ['users', 'organizations', 'phoneWidgetsList']

      return this.mainMenu.filter(menu => {
        if (always.includes(menu.to)) {
          return true
        }

        if (menu.to === 'agents' && (this.organization.useChatCenter || this.organization.usePbx)) {
          return true
        }

        if (menu.to === 'formsList' && this.organization.useChatCenter) {
          return true
        }

        return (menu.label === 'PBX' && this.organization.usePbx) || (menu.label === 'Chat Center' && this.organization.useChatCenter)
      })
    }
  },
  async beforeMount() {
    if (this.organizations.length === 0) {
      this.loadingOrganizations = true
      this.$store.dispatch('contactMe/fetchOrganizations').finally(() => {
        this.loadingOrganizations = false
      })
    } else {
      this.loadingOrganizations = false
    }
  },
  watch: {
    organizationId() {
      if (this.$route.name !== 'selected-organization') {
        this.$router.push({ name: this.$route.name, params : { name: this.organization.name }})
      } else {
        this.$router.push({ name: 'selected-organization', params : { name: this.organization.name }})
      }
    } 
  }
}
</script>

<style>
#app-main-content > .main-configurations {
  display: inline-flex!important;
  min-width: 100%;
  min-height: 100%;
  /* margin: var(--column); */
  /* width: 100%; */
}

/* #app-main-content > .main-configurations nav,
#app-main-content > .main-configurations nav a,
#app-main-content > .main-configurations nav span {
  color: var(--light-menu-links-color)!important;
} */

#app-main-content > .main-configurations nav a {
  text-decoration: none;
  display: block;
  width:  100%;
}

#app-main-content > .main-configurations nav a {
  color: var(--light-menu-links-color);
  padding: 8px;
}

#app-main-content > .main-configurations nav .child a {
  border-left: 2px solid transparent;
}

#app-main-content > .main-configurations nav button {
  padding: 8px;
  padding-left: 0px;
  color: var(--light-menu-links-color);
}

#app-main-content > .main-configurations nav .has-not-child a{
  padding-left: 0;
}

#app-main-content > .main-configurations nav  a:hover {
  color: var(--hiperpbx-dark-green);
}

#app-main-content > .main-configurations nav .child:hover {
  border-left: 1px solid var(--hiperpbx-dark-green);
}

#app-main-content > .main-configurations nav .child a:hover{
  color: var(--hiperpbx-dark-green);
  border-left: 2px solid var(--hiperpbx-dark-green);
}

#app-main-content .main-configurations nav .router-link-active {
  color: var(--hiperpbx-dark-green);
}

</style>

<style scoped>
.main-configurations {
  padding: 0px;
  background-color: white;
  /* min-width: 100%;
  min-height: 100%; */
  /* overflow-y:hidden; */
}

.main-configurations > nav {
  width: 200px;
  font-size: 14px;
  border-right: 1px solid #dcdfe6;
  padding: var(--column);
}

.main-configurations > nav i {
  margin-right: 8px;
}

.view {
  flex: 1
}

.breadcrumbs {
  margin: var(--column);
  margin-bottom: 0;
  font-size: 14px;
}
</style>